import { useState } from "react";
import ContractList from "@/components/leasing/ContractList";
import ReportL1 from "@/components/leasing/ReportL1";
import ReportL2 from "@/components/leasing/ReportL2";
import ReportL3 from "@/components/leasing/ReportL3";
import HelpButton from "@/components/HelpButton";

const FINANCERS = [
  { code: "DL", label: "Deutsche Leasing" },
  { code: "BP", label: "BNP Paribas" },
  { code: "RL", label: "Raiffeisen Leasing" },
  { code: "PL", label: "Porsche Leasing" },
];

const VIEWS = [
  { key: "contracts", label: "Contracte" },
  { key: "l1", label: "L1 · Capital & valoare rămasă" },
  { key: "l2", label: "L2 · Overview perioadă" },
  { key: "l3", label: "L3 · Centralizator" },
];

export default function Leasing() {
  const [financer, setFinancer] = useState("DL");
  const [view, setView] = useState("contracts");

  return (
    <div className="space-y-5">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Leasing</h1>
          <HelpButton anchor={view === "contracts" ? "contracte" : "rapoarte-leasing"} />
        </div>
        <p className="text-sm text-slate-500">Scadențare, capital/dobândă și rapoarte per finanțator.</p>
      </div>

      <div className="flex flex-wrap gap-1 border-b">
        {FINANCERS.map((f) => (
          <button
            key={f.code}
            data-testid={`tab-financer-${f.code}`}
            onClick={() => setFinancer(f.code)}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              financer === f.code
                ? "border-[#FFC800] text-slate-900"
                : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-1">
        {VIEWS.map((v) => (
          <button
            key={v.key}
            data-testid={`view-${v.key}`}
            onClick={() => setView(v.key)}
            className={`px-3 py-1.5 text-xs font-semibold rounded transition-colors ${
              view === v.key ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>

      <div key={`${financer}-${view}`}>
        {view === "contracts" && <ContractList financer={financer} />}
        {view === "l1" && <ReportL1 financer={financer} />}
        {view === "l2" && <ReportL2 financer={financer} />}
        {view === "l3" && <ReportL3 financer={financer} />}
      </div>
    </div>
  );
}
